/**
 * GoBox Hero - JavaScript Functionality
 * Handles letter-by-letter heading animation on scroll
 */

(function() {
  'use strict';

  function init() {
    setupLetterAnimation();
  }

  /**
   * Letter-by-letter heading animation based on scroll
   */
  function setupLetterAnimation() {
    const headings = document.querySelectorAll('.letter-animated-heading');
    if (headings.length === 0) return;

    headings.forEach((heading) => {
      const sectionId = heading.id.replace('heading-text-', '');
      const firstLine = heading.querySelector(`#heading-first-line-${sectionId}`);
      const secondLine = heading.querySelector(`#heading-second-line-${sectionId}`);
      
      if (!firstLine || !secondLine) return;

      function updateHeadingAnimation() {
        const rect = heading.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const sectionTop = rect.top;
        const sectionHeight = rect.height;

        // Define scroll range for animation
        const startPoint = windowHeight * 0.8;
        const endPoint = -sectionHeight + (windowHeight * 0.2);
        const scrollRange = startPoint - endPoint;

        // Calculate scroll progress (0 to 1)
        let progress = 0;
        if (sectionTop < startPoint && sectionTop > endPoint) {
          const scrolled = startPoint - sectionTop;
          progress = Math.max(0, Math.min(1, scrolled / scrollRange));
        } else if (sectionTop <= endPoint) {
          progress = 1;
        }

        // Update first line letters
        const firstLineLetters = firstLine.querySelectorAll('.heading-letter[data-line="first"]');
        firstLineLetters.forEach((letter, i) => {
          const letterProgress = (progress * firstLineLetters.length) - i;
          const opacity = Math.max(0, Math.min(1, letterProgress));
          const isPeriod = letter.textContent === '.';
          
          if (isPeriod) {
            letter.style.color = 'rgba(185, 28, 28, 1)';
          } else {
            letter.style.color = opacity >= 0.5 
              ? 'rgb(255, 255, 255)' 
              : 'rgba(255, 255, 255, 0.15)';
          }
        });

        // Update second line letters
        const secondLineLetters = secondLine.querySelectorAll('.heading-letter[data-line="second"]');
        secondLineLetters.forEach((letter, i) => {
          const globalIndex = firstLineLetters.length + i;
          const letterProgress = (progress * (firstLineLetters.length + secondLineLetters.length)) - globalIndex;
          const opacity = Math.max(0, Math.min(1, letterProgress));
          const isPeriod = letter.textContent === '.';
          
          if (isPeriod) {
            letter.style.color = 'rgba(185, 28, 28, 1)';
          } else {
            letter.style.color = opacity >= 0.5 
              ? 'rgb(255, 255, 255)' 
              : 'rgba(255, 255, 255, 0.15)';
          }
        });
      }

      // Throttle scroll events for better performance
      let ticking = false;
      function requestTick() {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            updateHeadingAnimation();
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', requestTick, { passive: true });
      updateHeadingAnimation(); // Initial call
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
